function ButtonPrimary({children, text, onClick, type, buttonType="button", disabled=false}) {
  return (
    <div className="flex">
      <button type={buttonType} className={`primary-button ${type}`} onClick={onClick} disabled={disabled}>
        <span className="icon">{children}</span>
        <span className="text" style={children ? {marginLeft:"10px"} : {}}>{text}</span>
      </button>
    </div>
    
  )
}

export default ButtonPrimary
